export default __webpack_public_path__ + "static/empire-home-slider-one-a822c3bb051d31a04f43f09703e7e359.jpg";